<template lang="pug">
  portal(:to="`${dialogId}.content`" v-slot="{ close }")
    .d-flex.flex-column.gap-24
      h3 Пожалуйста укажите недостающие сведения:
      main-edit-form(
        :active-fields="emptyFields"
        hide-disabled
        @saved="close"
      )
        template(#save="{ loading, hasChanges, update }")
          .d-flex.align-center.gap-12.mt-4.full-width
            dv-btn.flex-1(
              outlined
              large
              @click="close"
            ) Закрыть
            dv-btn.flex-1(
              large
              :loading="loading"
              :disabled="!hasChanges"
              @click="update"
            ) Сохранить
</template>

<script>
import DvBtn from '@/packages/ui/components/buttons/DvBtn.vue';
import { uniqueId } from 'lodash';
import MainEditForm from '@/modules/UserProfile/components/Profile/Roles/Organization/Sections/Main/MainEditForm.vue';

export default {
  components: {
    DvBtn,
    MainEditForm,
  },
  props: {
  },
  filters: {
  },
  data() {
    return {
      dialogId: uniqueId('profile-unfilled-data-dialog-'),
    };
  },
  computed: {
    emptyFields() {
      const { isOrganization, profile, isPfdoCreated } = this.$user || {};
      if (!isOrganization) return [];
      const fields = (profile?.empty_fields || []).filter((i) => !['full_name', 'short_name'].includes(i));
      if (isPfdoCreated) {
        return fields.filter((i) => !['inn'].includes(i));
      }
      return fields;
    },
  },
  watch: {
    'emptyFields.length': {
      handler() {
        this.checkIfFullfilledProfile();
      },
    },
  },
  mounted() {
    setTimeout(() => {
      this.checkIfFullfilledProfile();
    }, 500);
  },
  methods: {
    checkIfFullfilledProfile() {
      if ((this.emptyFields.length) && (this.$route.name !== 'ui-profile') && (this.$route.meta?.layout !== 'empty')) {
        this.openDialog();
      }
    },
    openDialog() {
      this.$dialogs.portal({
        attrs: {
          'max-width': 800,
          title: 'Необходимо заполнить информацию об организации',
          hideActions: true,
          inputValue: this.dialogId,
          scrollable: false,
          'card-attrs': {
            class: 'ui-design',
          },
        },
      });
    },
  },
};
</script>
